export default "__VITE_ASSET__2m$h047i__"